<div class="layout-cotainer">
  <div class="layout-background-image"></div>
  <div class="layout-form-container" [ngSwitch]="currentStep">
    <app-potential-customer
      *ngSwitchCase="1"
      class="form-component"
      (onBack)="backForm()"
      (onComplete)="changeForm($event)"
    ></app-potential-customer>
    <app-confirm-location
      *ngSwitchCase="2"
      class="form-component"
      (onBack)="backForm()"
      (onComplete)="changeForm($event)"
    ></app-confirm-location>
    <app-tax-validation
      *ngSwitchCase="3"
      class="form-component"
      (onBack)="backForm()"
      (onComplete)="changeForm($event)"
    ></app-tax-validation>
    <app-file-upload
      *ngSwitchCase="4"
      class="form-component"
      (onBack)="backForm()"
      (onComplete)="changeForm($event)"
    ></app-file-upload>
    <app-contact-information
      *ngSwitchCase="5"
      class="form-component"
      (onBack)="backForm()"
      (onComplete)="changeForm($event)"
    ></app-contact-information>
    <app-register-complete *ngSwitchCase="6" class="form-component"></app-register-complete>
    <app-version></app-version>
  </div>
</div>
